import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { useWishlist } from "../context/WishlistContext";

export default function Wishlist() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { ids } = useWishlist();

  const load = () => {
    setLoading(true);
    api.get("/wishlist").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [ids.length]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-12" data-testid="wishlist-page">
      <h1 className="font-display text-5xl uppercase tracking-tighter mb-2">My <span className="text-[#FF3B30]">Wishlist</span></h1>
      <p className="text-zinc-400 mb-10">Gear you're eyeing. Grab it before it's gone.</p>

      {loading ? (
        <div className="text-zinc-500 py-16">Loading…</div>
      ) : products.length === 0 ? (
        <div className="border border-zinc-800 bg-zinc-900 p-16 text-center" data-testid="wishlist-empty">
          <Heart className="mx-auto text-zinc-700 mb-6" size={56} />
          <h2 className="font-display text-3xl uppercase tracking-tight">Nothing Saved Yet</h2>
          <p className="text-zinc-400 mt-3">Tap the heart on any product to stash it here.</p>
          <Link to="/shop" className="mt-8 inline-flex items-center gap-2 bg-[#FF3B30] text-white font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200">Browse Gear</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
